import React from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Hero from './components/Hero';
import PropertyServices from './components/PropertyServices';
import RealEstateServices from './components/RealEstateServices';
import CabinRentals from './components/CabinRentals';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" />
      <Header />
      <main>
        <Hero />
        <PropertyServices />
        <RealEstateServices />
        <CabinRentals />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
